import { Divider, Box } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useEsriMapStore } from '../../../hooks/use-esri-map-store';
import { LocationAddressAndGpsSection } from '../location-address-and-gps-section';
import { HospitalStatusSection } from './hospital-status-section';
import { HospitalOverview } from './hospital-overview';
import { PanelWrapper } from '../panel-wrapper';
import { useApplicationType } from '../../../../common/hooks/use-application-type';

export const HospitalPanel = observer(function HospitalPanel(): React.ReactElement | null {
    const mapStore = useEsriMapStore();
    const { isFirstResponder } = useApplicationType();
    const size = isFirstResponder ? 'lg' : 'md';

    const mapLedgerHospital = mapStore.selectedMapLedgerHospital;
    if (!mapLedgerHospital) {
        return null;
    }
    const {
        name: hospitalName,
        geoLocation,
        areCoordinatesVerified,
        placeName,
        displayLineFirst,
        displayLineLast,
        displayLineOptionalMiddle,
        displayLineSubPremise,
        locationSource,
        capabilities,
        status,
        statusGlobalAttributeId,
        lastUpdatedDateUtc,
        notes,
    } = mapLedgerHospital;
    return (
        <PanelWrapper testId="MAP_HOSPITAL_PANEL">
            <HospitalOverview hospitalName={hospitalName} size={size} />
            <LocationAddressAndGpsSection
                locationSectionTitle="Hospital Info"
                geoLocationLatitude={geoLocation?.latitude}
                geoLocationLongitude={geoLocation?.longitude}
                areGeoLocationCoordinatesVerified={areCoordinatesVerified}
                placeName={placeName}
                displayLineFirst={displayLineFirst}
                displayLineLast={displayLineLast}
                displayLineOptionalMiddle={displayLineOptionalMiddle}
                displayLineSubPremises={displayLineSubPremise}
                source={locationSource}
                showSectionDivider={false}
                size={size}
            />
            <Box marginLeft={18} marginRight={18}>
                <Divider />
            </Box>
            <HospitalStatusSection
                status={status}
                statusGlobalAttributeId={statusGlobalAttributeId}
                lastUpdatedDateUtc={lastUpdatedDateUtc}
                capabilities={capabilities}
                notes={notes}
                size={size}
            />
        </PanelWrapper>
    );
});
